// 菜单主题
export const MENU_THEME = 'MENU_THEME'
// 布局模式
export const LAYOUT = 'LAYOUT'
// 主题色
export const THEME_COLOR = 'THEME_COLOR'
// 菜单展开收起状态
export const MENU_COLLAPSED = 'MENU_COLLAPSED'
// 导航模式
export const NAV_MODE = 'NAV_MODE'
// logo 显示模式
export const LOGO_MODE = 'LOGO_MODE'
// 错误捕获
export const CATCH_ERROR = 'CATCH_ERROR'
